import { render } from "./MyInvestment.vue?vue&type=template&id=3612e1f6&scoped=true&ts=true"
import script from "./MyInvestment.vue?vue&type=script&lang=ts"
export * from "./MyInvestment.vue?vue&type=script&lang=ts"

import "./MyInvestment.vue?vue&type=style&index=0&id=3612e1f6&scoped=scss&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3612e1f6"]])

export default __exports__